module.exports = __webpack_public_path__ + "img/31ne.08ab5fa5.svg";